import * as THREE from "three";
import { Context } from "../core/context";
import { DBEntity, DbLine } from "@/CadEngine";
import {
  DrawOperationMovePointBeforeParams,
  DrawOperationMovePointParams,
  IModifyOperation,
  ModifyOperateState,
} from "./IModifyOperation";

import { ULabel } from "@/ui/ULabel";
import {
  CommonColor,
  DrawDoorOrWindowAcceptParams,
  DrawDoorOrWindowReturnData,
  DrawDoorWayLineAcceptParams,
  ElevationAnnotationModifyReturnData,
} from "@/core/Parameters";
import { WasmUtil } from "@/utils/WasmUtil";

class DrawDoorWayLineModify implements IModifyOperation {
  private m_context: Context;
  private m_locationObject: THREE.Line;
  private m_auxLine: THREE.Line | undefined;
  private m_returnData: {
    extendId: string | undefined;
    endPoint: THREE.Vector3 | undefined;
  } = {
    extendId: undefined,
    endPoint: undefined,
  };
  private m_TextLabel: ULabel;
  private m_curPoint: THREE.Vector3 = new THREE.Vector3();
  private m_points: THREE.Vector3[] = [];
  private m_scale: number = 1;
  private m_callbackUnderway: (point: THREE.Vector3) => void;
  private m_TextLabelLocation: THREE.Vector3 = new THREE.Vector3();
  private m_acceptParams: DrawDoorWayLineAcceptParams;
  private m_curSelect: DBEntity | undefined = undefined;

  constructor(context: Context, params: DrawDoorWayLineAcceptParams) {
    this.m_context = context;
    this.m_acceptParams = params;
    this.m_callbackUnderway = params.callbackUnderway;
    this.m_locationObject = context.ToolsManager.CreatedLocationLine();
    this.m_scale = this.m_context.ViewManager.ScreenModelScale;
    this.m_TextLabel = new ULabel(
      this.m_context.ViewManager,
      this.m_context.Dom
    );
    this.m_TextLabel.Visibility = true;
  }

  OnMovePointBefore(params: DrawOperationMovePointBeforeParams): void {}
  OnMovePoint(point: DrawOperationMovePointParams): void {
    this.m_curPoint = point.point.clone();
    this.m_locationObject.position.copy(this.m_curPoint);
    this.m_TextLabelLocation.x = this.m_curPoint.x + this.m_scale * 35;
    this.m_TextLabelLocation.y = this.m_curPoint.y - this.m_scale * 10;
    if (this.m_curSelect) {
      this.m_context.SelectionManager.RemoveSelect(this.m_curSelect);
      this.m_context.SelectionManager.SetSelected(this.m_curSelect);
    }

    if (this.m_points.length > 1) return;
    this.m_TextLabel.SetVaule(
      "请选取门,按ECS键将退出操作",
      this.m_TextLabelLocation,
      new THREE.Vector3(1, 0, 0)
    );
    if (this.m_points.length == 1) {
      this.m_TextLabel.SetVaule(
        "请点取落点,按ECS键将退出操作",
        this.m_TextLabelLocation,
        new THREE.Vector3(1, 0, 0)
      );
      this.m_auxLine?.geometry.setFromPoints([
        this.m_points[0],
        this.m_curPoint,
      ]);
      this.m_auxLine?.computeLineDistances();
    }
  }
  OnDownPoint(point: DrawOperationMovePointParams): void {
    let { obejct } = point;
    if (this.m_points.length == 1) {
      this.m_points.push(point.point.clone());
      this.m_callbackUnderway(point.point);
      this.m_TextLabel.SetVaule(
        "请确定操作,按ECS键将退出操作",
        this.m_TextLabelLocation,
        new THREE.Vector3(1, 0, 0)
      );
      this.m_returnData.endPoint = point.point.clone();
    }
    if (obejct?.length && !this.m_points.length) {
      let obj = obejct[0];
      if (obj instanceof DBEntity) {
        let layerName = this.m_context.ModelManager.GetLayerById(
          obj.layerId
        )?.Name;
        if (layerName == this.m_acceptParams.doorLayerName) {
          if (obj.root_reference_id) {
            let matrix = this.m_context.ModelManager.getInstancesMatrix(
              obj.root_reference_id
            )?.matrix;
            let position = new THREE.Vector3(
              matrix?.elements[12],
              matrix?.elements[13],
              matrix?.elements[14]
            );
            this.m_points.push(position.clone());
            this.m_curSelect = obj;
            this.m_returnData.extendId = obj.extend_id;
            this.m_auxLine = this.m_context.ToolsManager.CreatedAuxLine();
            this.m_context.SelectionManager.SetSelected(this.m_curSelect);
          }
        }
      }
    }
  }
  onKeyDown(e: KeyboardEvent): void {
    e.preventDefault();
    if (e.key == "Escape") {
      this.m_returnData = {
        extendId: undefined,
        endPoint: undefined,
      };
      this.m_context.ModifyManager.ModifyFinish(ModifyOperateState.complete);
    }
  }
  onKeyUp(e: KeyboardEvent): void {}

  OnZoom(camera: THREE.Camera): void {}

  Finish(operate: ModifyOperateState) {
    this.clear();
    if (operate == ModifyOperateState.complete) {
      return this.m_returnData;
    } else if (operate == ModifyOperateState.cancel) {
      return [];
    }
  }
  OnWheel(e: WheelEvent): void {
    this.m_scale = this.m_context.ViewManager.ScreenModelScale;
  }

  onMouseMove(e?: PointerEvent): void {}

  onMouseDown(e: PointerEvent): void {}

  onMouseUp(e: PointerEvent): void {}

  private clear() {
    this.m_context.ToolsManager.ObjectsClear([
      this.m_locationObject,
      this.m_auxLine!,
    ]);
    this.m_TextLabel?.dispose();
  }
}

export { DrawDoorWayLineModify };
